import React, { useContext } from 'react'
import PropTypes from 'prop-types'
import * as Styled from './HospitalLocations.styles'
import { TextContext } from 'hocs/TextContextProvider/TextContextProvider'
import { getDetailURL } from 'settings/app/urlHelpers'

const HospitalLocations = ({
  locations,
  toggleAllLocation,
  entryPoint,
  searchKey,
  searchType,
}) => {
  const initialShown = 5
  const [showAllLocation, setShowAllLocation] = React.useState(initialShown)
  const textContext = useContext(TextContext)

  const handleToggleLocation = () => {
    if (locations.length === showAllLocation) {
      setShowAllLocation(initialShown)
      toggleAllLocation(false)
    } else {
      setShowAllLocation(locations.length)
      toggleAllLocation(true)
    }
  }

  return (
    <Styled.HospitalLocations>
      <p className='locations-title'>
        {textContext['detailView.hospital.locationsTitle']}
      </p>
      {locations.slice(0, showAllLocation).map((location, index) => {
        const { address, locationId } = location
        return (
          <div key={ index } className={ 'address-item' }>
            <div className={ 'alphanumeric' }>
              {(index + 1 + 9).toString(36).toUpperCase()}
            </div>
            <Styled.AddressLink
              tag={ locationId ? 'a' : 'div' }
              href={
                locationId
                  ? getDetailURL({
                      id: locationId,
                      entryPoint,
                      city: address.city,
                      zip: address.zip,
                      key: searchKey,
                      type: searchType,
                    })
                  : undefined
              }>
              <span>{address.title}</span>
              <span>
                {address.street}, {address.zip} {address.city}
              </span>
            </Styled.AddressLink>
          </div>
        )
      })}

      {initialShown < locations.length && (
        <Styled.LoadMoreButton
          id='hospital-location-show-all'
          className='btn-moreFilters'
          text={
            locations.length === showAllLocation
              ? `${ textContext['detailView.showLessLocation'] }`
              : `${ textContext['detailView.showMoreLocation'] }`
          }
          onClick={ () => handleToggleLocation() }
        />
      )}
    </Styled.HospitalLocations>
  )
}

HospitalLocations.propTypes = {
  /** address data  **/
  locations: PropTypes.arrayOf(
    PropTypes.shape({
      address: PropTypes.shape({
        title: PropTypes.string.isRequired,
        street: PropTypes.string.isRequired,
        zip: PropTypes.string.isRequired,
        city: PropTypes.string.isRequired,
      }).isRequired,
      locationId: PropTypes.string,
    })
  ),
  /** trigger fullscreen event to patent **/
  toggleAllLocation: PropTypes.func.isRequired,
  entryPoint: PropTypes.string, // can be differ from the entryPoint of the local storage! e.g. at cross search
  searchKey: PropTypes.string,
  searchType: PropTypes.string,
}

export default HospitalLocations
